<template>
  <div class="collectionItemList">
    <!-- 미리보기 -->
    <div class="collectionCategory">
      <!-- 콜렉션 카테고리 -->
      <PageCateogry
        v-if="categoryList"
        :locale="locale"
        :categoryList="categoryList"
        :categoryListAll="categoryList"
        :categoryId="categoryId"
        @update="changeCategory" />
      <!-- //콜렉션 카테고리 -->
      <!-- 아이템 추가 -->
      <button
        v-if="categoryId !== 'unknown'"
        type="button"
        class="btn"
        @click="setDetail('new')">
        {{ locale.add_item }}
      </button>
      <!-- //아이템 추가 -->
      <!-- 순서 저장
      <button
        class="btn btnWhite btnSetOrder"
        @click="setShopItemIndex(null)">
        {{locale.save_order}}
      </button>
      //순서 저장 -->
    </div>
    <div v-if="message.category || message.items || message.error" class="message">
      <p v-if="message.category">{{ message.category }}</p>
      <p v-else-if="message.items">{{ message.items }}</p>
      <p v-else-if="message.error">{{ message.error }}</p>
    </div>
    <draggable
      v-if="list?.length > 0"
      v-model="list"
      tag="ul"
      :animation="200"
      :style="listStyle"
      class="collectionItems"
      :data-type="categorySettings.listType">
      <li
        v-for="(item, index) in list"
        :key="index"
        class="collectionItem"
        @click="setDetail(item.collectionItemId)">
        <div v-if="categorySettings.display.includes('image')" class="thumb"
          :style="itemStyle.listItemThumb">
          <div :style="itemStyle.thumb">
            <img v-if="item.attribute.thumb" :src="item.attribute.thumb" alt="" />
          </div>
        </div>
        <div class="itemInfo"
        :style="itemStyle.listItemText">
          <div class="left">
            <div v-if="categorySettings.display.includes('name') && item.collectionItemName[defaultLang]"
              class="name"
              :style="itemStyle.name">
              {{ item.collectionItemName[defaultLang] }}
            </div>
            <div v-if="categorySettings.display.includes('descTop') && item.attribute.descTop[defaultLang]"
              class="descTop"
              :style="itemStyle.descTop">
              <pre>{{ item.attribute.descTop[defaultLang] }}</pre>
            </div>
          </div>
          <div class="right">
            <div v-if="categorySettings.display.includes('descBottom') && item.attribute.descBottom[defaultLang]"
              class="descBottom"
              :style="itemStyle.descBottom">
              <pre>{{ item.attribute.descBottom[defaultLang] }}</pre>
            </div>
          </div>
        </div>
      </li>
    </draggable>
    <!-- //미리보기 -->
    <Detail
      v-if="detail"
      :locale="locale"
      :collectionItemId="detail"
      :categoryId="categoryId"
      :defaultLang="defaultLang"
      @completeSave="saveItem"
      @completeDelete="deleteItem"
      @close="setDetail(null)" />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import LANG from '@/common/lang'
import PageCateogry from './PageCateogry'
import Detail from './Detail'

export default {
  name: 'CollectionItemList',
  props: [
    'locale',
    'pageId',
    'categoryId',
    'defaultLang',
    'settings',
    'categorySettings',
    'itemList',
    'message'
  ],
  components: {
    draggable,
    PageCateogry,
    Detail
  },
  computed: {
    collectionPageCategory () {
      return this.$store.getters['collection/getPageCategory']
    },
    categoryList () {
      const categoryList = this._.cloneDeep(this.collectionPageCategory)
      return categoryList.concat([this.unknown])
    },
    categoryListAll () {
      const categoryList = this._.cloneDeep(this.collectionPageCategory)
      return categoryList.concat([this.unknown])
    },
    itemIndexIds () {
      const list = this.list
      return list.map(x => x.collectionItemId)
    },
    list: {
      get () {
        return this._.cloneDeep(this.itemList)
      },
      set (list) {
        this.$emit('update', list)
      }
    },
    listStyle () {
      const setting = this.$store.getters['setting/getData']
      const fontFamily = `${setting?.font.default}, ${setting?.font.default2}, ${setting?.font.default3}`
      const fontColor = this.settings.collectionPage.fontColor
      const columns = this.categorySettings.columnRatio.map(x => `${x}fr`).join(' ')
      const marginTb = parseInt(this.categorySettings.itemMarginTb) * 12
      const marginlr = 4 + (parseInt(this.categorySettings.itemMarginLr) - 1) * 8
      return {
        fontFamily: fontFamily,
        color: fontColor,
        gridTemplateColumns: columns,
        gridRowGap: `${marginTb}px`, // 1-12, 2-24, "3-36", 4-48, 5-60
        gridColumnGap: `${marginlr}px` // 1-4, "2-12", 3-20, 4-28, 5-36
      }
    },
    itemStyle () {
      const categorySettings = this.categorySettings
      const thumbRatio = categorySettings.imageRatio
      const thumbSize = (parseFloat(thumbRatio.height) / parseFloat(thumbRatio.width) * 100).toFixed(2)
      const itemRatio = categorySettings.itemRatio
      const listItemThumb = itemRatio.image
      const listItemText = itemRatio.text
      return {
        listItemThumb: {
          flex: listItemThumb
        },
        listItemText: {
          flex: listItemText
        },
        name: {
          fontSize: `${categorySettings.fontSize.name}px`
        },
        descTop: {
          fontSize: `${categorySettings.fontSize.descTop}px`
        },
        descBottom: {
          fontSize: `${categorySettings.fontSize.descBottom}px`
        },
        thumb: {
          paddingBottom: `${thumbSize}%`,
          backgroundColor: 'rgba(0,0,0,0.1)'
        }
      }
    }
  },
  watch: {
  },
  async created () {
    this.$store.commit('onLoading', true)
    // this.getPageCategory()
    if (!this.categoryId) {
      this.$router.replace({
        params: {
          categoryId: this.findFirstLeafCategoryId(this.categoryList[0])
        }
      })
    }
    this.$store.commit('onLoading', false)
  },
  data () {
    return {
      unknown: {
        categoryId: 'unknown',
        categoryLabel: LANG.valueObj('unknown')
      },
      // categoryList: [],
      // categoryListAll: [],
      // list: [],
      detail: null
    }
  },
  methods: {
    getPageCategory () {
      if (this.collectionPageCategory?.length === 0) {
        this.$router.replace({
          params: {
            categoryId: 'unknown'
          }
        })
      }
    },
    async setShopItemIndex (categoryId) {
      const data = {
        pageId: this.id,
        categoryId: categoryId || this.categoryId,
        pageItemIndex: this.itemIndexIds
      }
      // const res = await this.$store.dispatch('shop/setShopItemIndex', data)
      // if (res && res.status === 200) {
      //   // alert(this.locale.complete_save)
      // } else {
      //   const status = (res && res.message && res.message.code) || 500
      //   const message = this.getShopResultData(status)
      //   console.log(message)
      // }
      // return res
    },
    // 가장 하위 카테고리의 ID를 재귀적으로 탐색
    findFirstLeafCategoryId (category) {
      if (!category.subCategory || category.subCategory.length === 0) {
        return category.categoryId
      }
      return this.findFirstLeafCategoryId(category.subCategory[0])
    },
    // categoryId로 전체 트리에서 카테고리 찾기
    findCategoryById (categories, id) {
      for (const cate of categories) {
        if (cate.categoryId === id) return cate
        if (cate.subCategory) {
          const found = this.findCategoryById(cate.subCategory, id)
          if (found) return found
        }
      }
      return null
    },
    // 가장 하위카테고리 찾기
    findDeepestId (startId) {
      const findCategoryById = (categories, id) => {
        for (const cat of categories) {
          if (cat.categoryId === id) return cat
          if (cat.subCategory) {
            const found = findCategoryById(cat.subCategory, id)
            if (found) return found
          }
        }
        return null
      }
      // 가장 깊은 leaf까지 재귀적으로 탐색
      const findDeepestLeaf = (category) => {
        if (!category || !category.subCategory || category.subCategory.length === 0) {
          return category
        }
        // 하위가 여러 개면 모든 경로 탐색하여 가장 깊은 leaf 리턴
        let deepest = null
        let maxDepth = 0
        const dfs = (node, depth) => {
          if (!node.subCategory || node.subCategory.length === 0) {
            if (depth > maxDepth) {
              maxDepth = depth
              deepest = node
            }
            return
          }
          for (const child of node.subCategory) {
            dfs(child, depth + 1)
          }
        }
        dfs(category, 1)
        return deepest
      }
      const startCategory = findCategoryById(this.categoryListAll, startId)
      if (!startCategory) return startId
      const deepest = findDeepestLeaf(startCategory)
      return deepest?.categoryId ?? startId
    },
    changeCategory (categoryId) {
      const selectedCategory = this.findCategoryById(this.categoryListAll, categoryId)
      if (selectedCategory) {
        const deepestId = this.findDeepestId(categoryId)
        this.$router.push({
          params: {
            categoryId: deepestId
          }
        })
      }
    },
    setDetail (collectionItemId) {
      this.detail = collectionItemId
    },
    saveItem () {
      this.$emit('reload')
    },
    deleteItem () {
      this.$emit('reload')
    }
  }
}
</script>
